import React from 'react'

function HouseOffer() {
  return (
    <div>
          {/* <!-- House Offer Section Start --> */}
        <section class="house-offer-section fix section-padding section-bg">
            <div class="container">
                <div class="section-title text-center">
                    <h5 class="wow fadeInUp"><i class="flaticon-home"></i> HOUSE HIGHLIGHTS <i class="flaticon-home"></i></h5>
                    <h2 class="wow fadeInUp" data-wow-delay=".3s">What This House Offers</h2>
                </div>
                <div class="row row-cols-xl-5 row-cols-lg-3 row-cols-md-3 row-cols-sm-2 row-cols-1">
                    <div class="col wow fadeInUp">
                        <div class="house-offer-box">
                            <div class="icon">
                                <i class="flaticon-warehouse"></i>
                            </div>
                            <div class="content">
                                <h4>Warehouse</h4>
                                {/* <p>6 Properties</p> */}
                            </div>
                        </div>
                    </div>
                    <div class="col wow fadeInUp" data-wow-delay=".2s">
                        <div class="house-offer-box">
                            <div class="icon">
                               <i class="flaticon-villa"></i>
                            </div>
                            <div class="content">
                                <h4>Villa</h4>
                                {/* <p>6 Properties</p> */}
                            </div>
                        </div>
                    </div>
                    <div class="col wow fadeInUp" data-wow-delay=".4s">
                        <div class="house-offer-box">
                            <div class="icon">
                                <i class="flaticon-apartment"></i>
                            </div>
                            <div class="content">
                                <h4>Apartment</h4>
                                {/* <p>6 Properties</p> */}
                            </div>
                        </div>
                    </div>
                    <div class="col wow fadeInUp" data-wow-delay=".6s">
                        <div class="house-offer-box">
                            <div class="icon">
                                <i class="flaticon-home-1"></i>
                            </div>
                            <div class="content">
                                <h4>Homestay</h4>
                                {/* <p>6 Properties</p> */}
                            </div>
                        </div>
                    </div>
                    <div class="col wow fadeInUp" data-wow-delay=".8s">
                        <div class="house-offer-box">
                            <div class="icon">
                                <i class="flaticon-store"></i>
                            </div>
                            <div class="content">
                                <h4>Commercial</h4>
                                {/* <p>6 Properties</p> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
    </div>
  )
}

export default HouseOffer